import { PlusKit } from 'education-icons';
import { Button, Text } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { QuizEditorReelItem } from '../__reel-item/quiz-editor__reel-item';
import { actions } from '../actions';
import { getCurrentQuestionIndex, getQuestions, isReadOnly } from '../selectors';

import './quiz-editor__slides-reel.scss';

const MAX_QUESTIONS = 30;

export const QuizEditorSlidesReel = () => {
    const dispatch = useDispatch();

    const handleSlidePreviewClick = (index: number) => {
        dispatch(actions.setCurrentQuestionIndex(index));
    };

    const questions = useSelector(getQuestions);
    const currentQuestionIndex = useSelector(getCurrentQuestionIndex);
    const readOnly = useSelector(isReadOnly);

    const handleCopyClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        event.stopPropagation();
        dispatch(actions.copySlide(index));
    };

    const handleDeleteClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        event.stopPropagation();
        dispatch(actions.deleteSlide(index));
    };

    const handleAddSlide = () => {
        dispatch(actions.addSlide());
    };

    return (
        <div className="quiz-editor__slides-reel">
            <div className="slides-reel__container">
                {questions.map((question, index) => {
                    return (
                        <QuizEditorReelItem
                            index={index}
                            isActive={index === currentQuestionIndex}
                            key={index}
                            onClick={() => {
                                handleSlidePreviewClick(index);
                            }}
                            onCopy={(event: React.MouseEvent<HTMLElement>) => {
                                handleCopyClick(event, index);
                            }}
                            onDelete={(event: React.MouseEvent<HTMLElement>) => {
                                handleDeleteClick(event, index);
                            }}
                            shouldShowControls={!readOnly}
                            shouldShowDeleteButton={questions.length !== 1}
                            shouldShowWarning={!question.isValid}
                        />
                    );
                })}
            </div>

            {!readOnly && (
                <div className="slides-reel__add-slide-button-container">
                    <Button
                        className="slides-reel__add-slide-button"
                        disabled={questions.length >= MAX_QUESTIONS}
                        icon={<PlusKit />}
                        onClick={handleAddSlide}
                        view={Button.VIEW.SECONDARY}
                    >
                        <Text id="teacherLab.quizEditor.addQuestionButton" />
                    </Button>
                </div>
            )}
        </div>
    );
};
